export const menuItems = [
  {
    name: "wholesale",
    label: "Wholesale",
    isExternal: false
  },
  {
    name: "#",
    label: "Network",
    isExternal: false, 
    items: [
      { name: "broadband", isExternal: false, label: "Broadband" },
      { name: "areas", isExternal: false, label: "Areas" },
      { name: "rollout", isExternal: false, label: "Rollout" },
      { name: "wayleaves", isExternal: false, label: "Wayleaves" }
    ]
  },
  {
    name: "/about-us",
    label: "About",
    isExternal: false, 
    items: [
      { name: "news", isExternal: false, label: "News" },
      { name: "insights", isExternal: false, label: "Insights" },
      { name: "careers", isExternal: false, label: "Careers" },
      { name: "team", isExternal: false, label: "Team" }
    ]
  },
  {
    name: "#",
    label: "Funding",
    isExternal: false, 
    items: [
      { name: "gigabit-voucher-scheme", isExternal: false, label: "Voucher Scheme" },
      { name: "scottish-voucher-scheme", isExternal: false, label: "Scotland R100" },
    ]
  },
  {
    name: "#",
    label: "Help",
    isExternal: false, 
    items: [
      { name: "contact", isExternal: false, label: "Contact" },
      { name: "support", isExternal: false, label: "Support" },
      { name: "diversions", isExternal: false, label: "Diversions" },
    ]
  }
];
